import { Form, Row, Select, Spin, Col, Input, Button } from 'antd';
import React, { useEffect } from 'react';
import { ORDER_STATUSES } from '../../../constants';
import { ReactSVG } from 'react-svg';

const WebhooksForm = ({
  handleCancel,
  handleOk,
  webhook,
  isModalOpen,
  isFetching,
  // typePage = TYPE_PAGE.DRAFT
}) => {
  const [formWebhooks] = Form.useForm();

  useEffect(() => {
    if (webhook) {
      formWebhooks.setFieldsValue({
        ...webhook,
      });
    } else {
      formWebhooks.resetFields();
    }
  }, [formWebhooks, webhook, isModalOpen]);

  const onCancel = () => {
    handleCancel && handleCancel();
  };

  const onOk = () => {
    formWebhooks.submit();
  };

  const onFinishForm = (values) => {
    const params = { ...values };
    handleOk && handleOk(params);
  };
  const irrelevantStatusses = [ORDER_STATUSES.SKIPPED, ORDER_STATUSES.GEOCODING, ORDER_STATUSES.UNSCHEDULED];
  return (
    <Spin spinning={isFetching}>
      <div className="WebhooksForm">
        <Form
          form={formWebhooks}
          scrollToFirstError
          layout="vertical"
          requiredMark={false}
          colon={false}
          className="FormContent"
          onFinish={onFinishForm}
          //initialValues={initValuesForm}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Event" name="event" rules={[{ required: true, message: 'Required' }]}>
                <Select
                  options={Object.keys(ORDER_STATUSES)
                    .filter((s) => !irrelevantStatusses.includes(s))
                    .map((key) => ({ value: key }))}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Webhook URL" name="webhookURL" rules={[{ required: true, message: 'Required' }]}>
                <Input size="large" placeholder="www.your-webhook-url.com/my-endpoint" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <div className="FormFooter">
          <Button className="ButtonCancel" onClick={onCancel}>
            Cancel
          </Button>
          <Button className="CreateButton ButtonPrimary" type="primary" onClick={onOk}>
            {webhook ? 'Edit' : 'Create'}
            <ReactSVG className="icon" src="/icons/done.svg" />
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default WebhooksForm;
